(function (window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.DisplayMessages = window.JVZoo.DisplayMessages || {};
    window.JVZoo.DisplayMessages.MessageLevels = window.JVZoo.DisplayMessages.MessageLevels || {
        SUCCESS: 'success',
        INFO: 'info',
        WARNING: 'warning',
        ERROR: 'error',
    };

    var _selectors = {
        jvzDisplayMessagesContainers: '[name=jvzDisplayMessages]',
    };

    var _showSpeed = 1000;
    var _hideSpeed = _showSpeed/2;

    /**
     * Fades an HTML element into view
     * @param element
     * @returns {boolean}
     * @constructor
     */
    window.JVZoo.DisplayMessages.Show = function (element) {
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        $element.each(function (index, target) {
            $(target).fadeIn(_showSpeed);
        });
        return true;
    };

    /**
     * Fades an HTML element out of view
     * @param element The element to be removed
     * @param {boolean} remove If true, the element is removed after it fades from view
     * @param {number} speed If specified, overrides the default speed at which items are removed.
     * @return {boolean} True when successful, otherwise false
     * @constructor
     */
    window.JVZoo.DisplayMessages.Hide = function (element, remove, speed) {
        remove = typeof remove === "boolean" ? remove : false;
        speed = typeof speed === "number" ? speed : _hideSpeed;
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        if ($element.length === 1) {
            if (remove) {
                $element.fadeOut(speed, function () {
                    $(this).remove();
                });
                return true;
            }
            if ($element.is(':visible')) {
                $element.fadeOut(speed);
            }
            return true;
        }
        $element.each(function (index, target) {
            if (remove) {
                $(target).fadeOut(speed, function () {
                    $(this).remove();
                });
                return;
            }
            if ($element.is(':visible')) {
                $(target).fadeOut(speed);
            }
        });
        return true;
    };

    /**
     * @param element The html element to be faded from view and then removed from the page
     *
     * @return {boolean} True when successful, otherwise false
     * @constructor
     */
    window.JVZoo.DisplayMessages.Remove = function (element) {
        return window.JVZoo.DisplayMessages.Hide(element, true);
    };

    /**
     * Adds a display message to the collection of messages at the top of the screen
     *
     * @param {string} level a window.JVZoo.DisplayMessages.MessageLevels constant
     * @param {string} message
     * @param {string} messageName A value that can be used to remove this message later. See window.JVZoo.DisplayMessages.RemoveByName
     * @return {boolean} True when successful, otherwise false
     */
    window.JVZoo.DisplayMessages.Add = function (level, message, messageName) {
        if (!message || (typeof message) !== "string") {
            return false;
        }
        var $displayMessagesSection = $(_selectors.jvzDisplayMessagesContainers);
        if (!$displayMessagesSection.length) {
            return false;
        }
        var css = 'alert ';
        switch (level) {
            case window.JVZoo.DisplayMessages.MessageLevels.SUCCESS:
                css += 'alert-success';
                break;
            case window.JVZoo.DisplayMessages.MessageLevels.INFO:
                css += 'alert-info';
                break;
            case window.JVZoo.DisplayMessages.MessageLevels.WARNING:
                css += 'alert-warning';
                break;
            case window.JVZoo.DisplayMessages.MessageLevels.ERROR:
            default:
                css += 'alert-danger';
                break;

        }
        var nameAttribute = messageName ? "name=\""+ messageName+"\"" : "";
        var element = $("<div " + nameAttribute + " class=\"alert " + css + "\" role=\"alert\">" + message + "</div>");
        element.hide();
        $displayMessagesSection.prepend(element);
        var result = window.JVZoo.DisplayMessages.Show(element);
        scrollTo(element);
        return result === true;
    };

    /**
     * Removes all display messages
     *
     * @return {boolean} True when successful, otherwise false
     */
    window.JVZoo.DisplayMessages.Clear = function () {
        var $displayMessagesSection = $(_selectors.jvzDisplayMessagesContainers);
        if (!$displayMessagesSection.length) {
            return false;
        }
        var result = true;
        $displayMessagesSection.children().each(function (index, element) {
            result &= window.JVZoo.DisplayMessages.Remove(element);
        });
        return result;
    };

    /**
     * Removes all display messages within the display messages container that have a matching attribute
     *
     * @return {boolean} True when successful, otherwise false
     */
    window.JVZoo.DisplayMessages.RemoveByName = function (messageName) {
        if (!messageName) {
            return false;
        }
        var $displayMessagesSection = $(_selectors.jvzDisplayMessagesContainers);
        if (!$displayMessagesSection.length) {
            return false;
        }
        var result = true;
        $displayMessagesSection.children("[name="+messageName+"]").each(function (index, element) {
            result &= window.JVZoo.DisplayMessages.Remove(element);
        });
        return result === true;
    };

    var scrollTo = function(target) {
        $('html, body').animate(
            {
                scrollTop: $(_selectors.jvzDisplayMessagesContainers).first().offset().top - 10,
            },
            500,
            'linear'
        )
    }

    window.JVZoo.DisplayMessages.ProcessUserDisplayMessages = function (messagesContainer) {
        if (!messagesContainer) {
            if (window.JVZoo.Debug) {
                console.warn('window.JVZoo.DisplayMessages.processUserMessages was called for an empty parameter.');
            }
            return false;
        }

        if (!messagesContainer.displayMessages || messagesContainer.displayMessages.length < 1) {
            if (window.JVZoo.Debug) {
                console.info('window.JVZoo.DisplayMessages.processUserMessages was called for a container without any display messages.');
            }
            return false;
        }

        var result = true;
        messagesContainer.displayMessages.forEach(

            function (userMessage) {
                if (!userMessage.level) {
                    console.error("User message did not include a 'level' field.");
                    return result &= false;
                }
                if (!userMessage.message) {
                    console.error("User message did not include a 'level' field.");
                    return result &= false;
                }
                var messageName = userMessage.name || null;
                result &= window.JVZoo.DisplayMessages.Add(userMessage.level, userMessage.message, messageName);
            }
        );
        return result;
    };
})
(window, jQuery);